module.exports = __webpack_public_path__ + "static/media/football-carousel-360x640.72af361f.jpg";